import React, { Fragment } from 'react'
import { Modal } from 'react-bootstrap'
import Logo from 'asset/images/logo.png'
import Input from 'component/form/Input';
import { CheckCircleIcon, SearchIcon } from 'asset/icons';
import { Bars } from 'react-loader-spinner';
import capitalizeWords from 'utilities/capitalizeWords';
import getInitials from 'utilities/getInitials';
import useNetworkUsers from 'hooks/useNetworkUsers';

const ShippingAgentModal = ({
    show,
    setShow,
    updateShippingLeg,
    leg,
    selectedUser,
    setSelectedUser,
    setAddNetworkModal,
}) => {
    const { setSearchString, alphabets, suppliers, suppliersLoading, nameToUse } =
        useNetworkUsers();

    return (
        <div className="w-full h-full modal">
            <Modal
                show={show}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="border-0"
            >
                <Modal.Body
                    style={{ maxHeight: "90vh" }}
                    className="rounded-2xl overflow-hidden bg-[#F5F4FA]"
                >
                    <div className="flex items-start justify-between">
                        <h3 className="text-2xl">Assign clearing agent</h3>
                        <span
                            className="cursor-pointer material-icons"
                            style={{ color: "#667085" }}
                            onClick={() => {
                                setShow(false);
                            }}
                        >
                            close
                        </span>
                    </div>
                    <p className="text-gray-10">
                        Choose a clearing agent to handle customs clearance
                    </p>

                    <div
                        onClick={() => {
                            updateShippingLeg(
                                leg.id,
                                "isClearingAgent",
                                !leg?.isClearingAgent ? true : false
                            );
                            setShow(false);
                        }}
                        className="relative flex gap-2 p-3 mt-3 bg-white rounded-lg cursor-pointer"
                    >
                        <div className="grid items-center bg-purple-100 rounded-full place-items-center size-10">
                            <img src={Logo} alt="logo" className="size-5" />
                        </div>

                        <div>
                            <p className="text-sm font-medium">Truck with Tradevu</p>
                            <p className="text-xs font-light text-main-grey">
                                Fulfil this shipment with vetted truckers from Tradevu.
                            </p>
                        </div>

                        <div
                            style={{
                                background: "linear-gradient(90deg, #65C71B 0%, #85E13A 100%)",
                            }}
                            className="absolute top-0 right-0 inline-block px-2 py-1 text-white rounded-tr-lg"
                        >
                            <p className="text-sm font-normal">Recommended</p>
                        </div>

                        {leg?.isClearingAgent && (
                            <CheckCircleIcon className="ml-auto !mr-3 mt-3 !size-5" />
                        )}
                    </div>
                    <div className="my-3">
                        <Input
                            onChange={(value) => setSearchString(value.toLowerCase())}
                            placeholder="Search by name, email or business"
                            unit={<SearchIcon className="-order-1  !ml-4 !size-6" />}
                            className="!shadow-[inset_0_0_0_1000px_#EAECF0] !pl-3 placeholder:text-base placeholder:font-normal"
                        />
                    </div>

                    <div className="flex items-center justify-between my-2 gap-x-2">
                        <div className="w-5/6 border-t" />
                        <p className="inline-block w-full text-xs uppercase text-nowrap text-main-grey">
                            or select from your network
                        </p>
                        <div className="w-5/6 border-t" />
                    </div>

                    <div className={`max-h-[40vh] overflow-y-auto rounded-lg !mt-4 !mb-6 !px-6`}>
                        {!suppliersLoading && suppliers?.length ? (
                            <>
                                {alphabets.map((letter, letterIdx) => (
                                    <Fragment key={letter}>
                                        <p
                                            className={`font-medium  text-left text-xs text-[#667085] ${
                                                letterIdx && "!mt-[15px]"
                                            } !mb-2`}
                                        >
                                            {letter}
                                        </p>
                                        <div
                                            className={`rounded-lg !px-2 bg-white flex flex-col gap-2.5 !py-2.5 border`}
                                        >
                                            {suppliers
                                                .filter((supp) =>
                                                    nameToUse(supp).startsWith(letter.toLowerCase())
                                                )
                                                .map((user) => {
                                                    return (
                                                        <div
                                                            className={`flex items-center gap-2 !py-1.5 cursor-pointer rounded-lg`}
                                                            onClick={() => {
                                                              updateShippingLeg
                                                                  ? updateShippingLeg(
                                                                        leg.id,
                                                                        'clearingAgent', {
                                                                        name: nameToUse(user),
                                                                        _id: user._id,
                                                                        personalName: `${
                                                                            user.firstName ?? ""
                                                                        } ${user.lastName ?? ""}`,
                                                                        ...user,
                                                                    },
                                                                    )
                                                                  : setSelectedUser({
                                                                        name: nameToUse(user),
                                                                        _id: user._id,
                                                                        personalName: `${
                                                                            user.firstName ?? ""
                                                                        } ${user.lastName ?? ""}`,
                                                                        ...user,
                                                                    });
                                                                setShow(false);
                                                            }}
                                                            key={user._id}
                                                        >
                                                            <span
                                                                className={`!size-10 bg-[#F6F6F6] rounded-full text-[#344054] font-[450] grid place-items-center overflow-hidden ${
                                                                    getInitials(nameToUse(user))
                                                                        .length > 3 && "text-[13px]"
                                                                }`}
                                                            >
                                                                {getInitials(nameToUse(user))}
                                                            </span>
                                                            <p className="text-main-dark font-[450]">
                                                                {capitalizeWords(
                                                                    nameToUse(user) ?? ""
                                                                )}
                                                            </p>

                                                            {selectedUser?._id === user._id && (
                                                                <CheckCircleIcon className="ml-auto !mr-2 !size-5" />
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </Fragment>
                                ))}
                            </>
                        ) : (
                            <div className="h-[80px] grid place-items-center">
                                {suppliersLoading ? (
                                    <Bars
                                        height="22"
                                        width="22"
                                        color="#6f00ff"
                                        ariaLabel="bars-loading"
                                    />
                                ) : (
                                    <span className="block text-center text-main">
                                        No user found
                                    </span>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="flex items-center justify-between gap-2 px-4 py-2 text-xs border-t rounded-sm border-t-gray-200">
                        <p className="font-light">You can add a new agent to your network</p>
                        <div className="flex justify-end gap-2">
                            <button
                                onClick={() => setShow(false)}
                                className="px-4 py-2 text-gray-700"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => {
                                    setAddNetworkModal((p) => !p);
                                    setShow(false);
                                }}
                                className="px-3 py-1 text-[#5E01D6] bg-[#EBE4FF] rounded-md text-md"
                            >
                                Add New
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default ShippingAgentModal